const baseURL = 'https://restaurante.encatalogo.com';

export default baseURL;
